// extracted by mini-css-extract-plugin
export default {"blackOverlay":"Modal_blackOverlay__U6+0R","verticalAligner":"Modal_verticalAligner__tgVaV","whiteWindow":"Modal_whiteWindow__eTzaM","modalContent":"Modal_modalContent__V2ThR"};